var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "relative block" },
    [
      _vm._t("before"),
      _c("base-label", {
        attrs: {
          label: _vm.label,
          labelClasses: _vm.labelClasses,
          disabled: _vm.disabled,
          required: _vm.required,
          tooltip: _vm.tooltip,
        },
      }),
      _vm.isReadOnly
        ? _c("base-read-only-field", {
            attrs: {
              value: _vm.localValue,
              tooltip: _vm.readOnlyTooltip,
              "read-only-classes": _vm.readOnlyClasses,
            },
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.localValue,
                expression: "localValue",
                modifiers: { trim: true },
              },
            ],
            ref: "base-input",
            class: [
              "form-input block min-w-48 w-full",
              _vm.inputClasses,
              _vm.anyError ? "form-input-error" : "",
            ],
            style: _vm.inputStyle,
            attrs: {
              type: _vm.type,
              placeholder: _vm.disabled ? "" : _vm.placeholder,
              disabled: _vm.disabled,
              maxlength: _vm.maxLength,
            },
            domProps: { value: _vm.localValue },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.localValue = $event.target.value.trim()
                },
                _vm.onInput,
              ],
              change: _vm.onChange,
              focus: _vm.onFocus,
              blur: [
                _vm.onBlur,
                function ($event) {
                  return _vm.$forceUpdate()
                },
              ],
              animationstart: _vm.animationStart,
              animationend: _vm.animationEnd,
              focusout: _vm.focusout,
            },
          }),
      _vm._t("bubble"),
      _vm._t("after"),
      _vm.anyWarning && !_vm.anyError
        ? _c("span", { staticClass: "form-warning" }, [
            _vm._v(" " + _vm._s(_vm.anyWarning) + " "),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }